var locale = {
    placeholder: 'Select time'
};
export default locale;